export default __webpack_public_path__ + "static/player-lounge-67b26e87a0cf025b90a9e7290c41290b.png";